import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
@Component({
  selector: "sm-domain-mapping",
  templateUrl: "./domain-mapping.component.html",
  styleUrls: ["./domain-mapping.component.scss"],
})
export class DomainMappingComponent implements OnInit {
  domainName: any;
    initialDomainName: any; // Add this property to track the original value

  apisub: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private ls: LoaderServiceService,
    private apiservice: ApiService,
    private activemodal: MatDialogRef<DomainMappingComponent>,
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_REQUEST_ENTITY_DOMAIN_MAPPING
      ) {
        if (resdata.result) {
          this.activemodal.close({ msg: "success" });
        }
      }
    });
  }
  domainData: any;

  ngOnInit(): void {
    this.domainData = this.parentdata.domainMappingData;

    this.domainName = this.parentdata.domainMappingData?.domain_name;

        // Set the initial value for comparison
    this.initialDomainName = this.domainName;
  }

    get isSaveDisabled(): boolean {
    // Disable if the name is empty OR if it hasn't changed from the original
    return !this.domainName || this.domainName.trim() === '' || this.domainName === this.initialDomainName;
  }

  onsave() {
    let obj = {
      entity_hash: this.parentdata.entity_hash,
      domain_name: this.domainName,
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      hash_id: this.domainData?.hash_id,
    };
    Object.keys(obj).forEach((key) => {
      if (
        (obj as any)[key] === null ||
        (obj as any)[key] === undefined ||
        (obj as any)[key] === "" ||
        (obj as any)[key] === "null"
      ) {
        delete (obj as any)[key];
      }
    });
    this.ls.showLoader = true;
    this.apiservice.requestEntityDomainMapping(obj);
  }
}
